// import { Component, OnInit } from '@angular/core';
// import { HomeService } from 'src/home/home.service';
// import { ProviderFailed, ProvidersFailed } from 'src/models/ProviderFailed';
// import { FormBuilder, FormGroup, Validators } from '@angular/forms';
// import Swal from 'sweetalert2';
// import { MatPaginatorIntl, PageEvent } from '@angular/material/paginator';
// import { PaginatorService } from 'src/home/paginator.service';
// import { BillingService } from '../services/billing.service';

// @Component({
//   selector: 'app-billing-failed-providers',
//   templateUrl: './billing-failed-providers.component.html',
//   styleUrls: ['./billing-failed-providers.component.css'],
//   providers: [{ provide: MatPaginatorIntl, useClass: PaginatorService }],
// })
// export class BillingFailedProvidersComponent implements OnInit {
//   currentPage: number = 1;
//   itemsPerPage: number = 10;
//   totalItems: number = 0;
//   failedProviders: ProviderFailed[] = [];
//   isLoading: boolean = false;

//   billingForm!: FormGroup;

//   constructor(private fb: FormBuilder, private billingService: BillingService
//   ) { }

//   ngOnInit(): void {
//     this.billingForm = this.fb.group({
//       startDate: ['', [Validators.required]],
//       endDate: ['', [Validators.required]],
//     });

//     this.loadFailedProviders();
//   }

//   loadFailedProviders(): void {
//     this.isLoading = true;
//     this.billingService.getPendingProviders().subscribe(
//       (data: ProvidersFailed) => {
//         this.isLoading = false;
//         if (data && data.results) {
//           this.failedProviders = data.results;
//           this.totalItems = data.results.length;
//           if (this.failedProviders.length === 0) {
//             Swal.fire({
//               title: 'Sin resultados',
//               text: 'No se encontraron proveedores fallidos.',
//               icon: 'info',
//               confirmButtonText: 'Entendido',
//               confirmButtonColor: '#d33'
//             });
//           }
//         } else {
//           console.error(
//             'Error cargando proveedores fallidos: Formato de respuesta inesperado'
//           );
//         }
//       },
//       (error) => {
//         this.isLoading = false;
//         console.error('Error cargando proveedores fallidos:', error);
//         Swal.fire({
//           title: 'Error',
//           text: 'Ha ocurrido un error al cargar los proveedores fallidos. Por favor, inténtalo de nuevo.',
//           icon: 'error',
//           confirmButtonColor: '#d33',
//         });
//       }
//     );
//   }

//   handlePageEvent(event: PageEvent): void {
//     this.currentPage = event.pageIndex + 1;
//     this.itemsPerPage = event.pageSize;
//     this.loadFailedProviders();
//   }

//   sendFailedProviderBillingData(provider: ProviderFailed): void {
//     if (this.billingForm.valid) {
//       const { startDate, endDate } = this.billingForm.value;
//       const formattedStartDate = new Date(startDate).toLocaleDateString(
//         'es-ES'
//       );
//       const formattedEndDate = new Date(endDate).toLocaleDateString('es-ES');

//       const requestData = {
//         providerId: provider.providerId,
//         startDate: formattedStartDate,
//         endDate: formattedEndDate,
//       };

//       this.isLoading = true;
//       this.billingService.sendProviderBillingData(requestData).subscribe({
//         next: (response) => {
//           this.isLoading = false;
//           Swal.fire({
//             title: '¡Éxito!',
//             text: `El proceso de facturación ha sido lanzado para el proveedor ${provider.providerName}. El ID de proceso es: ${response.billingProcessId}`,
//             icon: 'success',
//             confirmButtonText: 'Entendido',
//           });
//         },
//         error: (error) => {
//           this.isLoading = false;
//           Swal.fire({
//             title: 'Error',
//             text: 'Hubo un problema al enviar los datos de facturación. Por favor, inténtalo de nuevo.',
//             icon: 'error',
//           });
//         },
//       });
//     } else {
//       Swal.fire({
//         title: 'Atención',
//         text: 'Completa correctamente todos los campos requeridos.',
//         icon: 'info',
//         confirmButtonText: 'Entendido',
//       });
//     }
//   }
// }

import { Component, OnInit } from '@angular/core';
import { HomeService } from 'src/home/home.service';
import { ProviderFailed, ProvidersFailed } from 'src/models/ProviderFailed';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import Swal from 'sweetalert2';
import { MatPaginatorIntl, PageEvent } from '@angular/material/paginator';
import { PaginatorService } from 'src/home/paginator.service';
import { BillingService } from '../services/billing.service';

@Component({
  selector: 'app-billing-failed-providers',
  templateUrl: './billing-failed-providers.component.html',
  styleUrls: ['./billing-failed-providers.component.css'],
  providers: [{ provide: MatPaginatorIntl, useClass: PaginatorService }],
})
export class BillingFailedProvidersComponent implements OnInit {
  currentPage: number = 1;
  itemsPerPage: number = 10;
  totalItems: number = 0;
  failedProviders: ProviderFailed[] = [];
  isLoading: boolean = false;

  billingForm!: FormGroup;

  constructor(private fb: FormBuilder, private billingService: BillingService) { }

  ngOnInit(): void {
    this.billingForm = this.fb.group({
      startDate: ['', [Validators.required]],
      endDate: ['', [Validators.required]],
    });

    this.loadFailedProviders();
  }

  loadFailedProviders(): void {
    this.isLoading = true;
    this.billingService.getPendingProviders().subscribe(
      (data: ProvidersFailed) => {
        this.isLoading = false;
        if (data && data.results) {
          this.failedProviders = data.results;
          this.totalItems = data.results.length;
        } else {
          console.error(
            'Error cargando proveedores fallidos: Formato de respuesta inesperado'
          );
        }
      },
      (error) => {
        this.isLoading = false;
        console.error('Error cargando proveedores fallidos:', error);
        Swal.fire({
          title: 'Error',
          text: 'Ha ocurrido un error al cargar los proveedores fallidos. Por favor, inténtalo de nuevo.',
          icon: 'error',
          confirmButtonColor: '#d33',
        });
      }
    );
  }

  handlePageEvent(event: PageEvent): void {
    this.currentPage = event.pageIndex + 1;
    this.itemsPerPage = event.pageSize;
    this.loadFailedProviders();
  }

  sendFailedProviderBillingData(provider: ProviderFailed): void {
    if (this.billingForm.valid) {
      const { startDate, endDate } = this.billingForm.value;
      const formattedStartDate = new Date(startDate).toLocaleDateString('es-ES');
      const formattedEndDate = new Date(endDate).toLocaleDateString('es-ES');

      const requestData = {
        providerId: provider.providerId,
        startDate: formattedStartDate,
        endDate: formattedEndDate,
      };

      this.isLoading = true;
      this.billingService.sendProviderBillingData(requestData).subscribe({
        next: (response) => {
          this.isLoading = false;
          Swal.fire({
            title: '¡Éxito!',
            text: `El proceso de facturación ha sido lanzado para el proveedor ${provider.providerName}. El ID de proceso es: ${response.billingProcessId}`,
            icon: 'success',
            confirmButtonText: 'Entendido',
          });
        },
        error: (error) => {
          this.isLoading = false;
          Swal.fire({
            title: 'Error',
            text: 'Hubo un problema al enviar los datos de facturación. Por favor, inténtalo de nuevo.',
            icon: 'error',
          });
        },
      });
    } else {
      Swal.fire({
        title: 'Atención',
        text: 'Completa correctamente todos los campos requeridos.',
        icon: 'info',
        confirmButtonText: 'Entendido',
      });
    }
  }
}
